// extracted by mini-css-extract-plugin
export var downArrow = "_a0-0";
export var infoTooltipIcon = "_a0-3";
export var label = "_a0-1";
export var optionCard = "_a0-4";
export var upArrow = "_a0-2";